import { LayoutModule } from '@angular/cdk/layout';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { ConfirmEmailComponent } from '@app/auth/confirm-email/confirm-email.component';
import { LayoutComponent } from '@app/auth/layout/layout.component';
import { LoginComponent } from '@app/auth/login/login.component';
import { ResetpasswordComponent } from '@app/auth/resetpassword/resetpassword.component';
import { SignupComponent } from '@app/auth/signup/signup.component';
import { CoreModule } from '@app/core/core.module';
import { StoreAdminAuthGuard } from '@app/core/guards/store-admin.guard';
import { SuperAdminAuthGuard } from '@app/core/guards/super-admin.guard';
import { UserGuard } from '@app/core/guards/user.guard';
import { MaterialModule } from '@app/material/material.module';
import { NotFoundComponent } from '@app/not-found/not-found.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { AboutUsLandingComponent } from './auth/about-us-landing/about-us-landing.component';
import { ConfirmDialougeComponent } from './auth/confirm-dialouge/confirm-dialouge.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { ForceChangePasswordComponent } from './auth/force-change-password/force-change-password.component';
import { HoodiesComponent } from './auth/hoodies/hoodies.component';
import { HowItWorksComponent } from './auth/how-it-works/how-it-works.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { TextDialogueComponent } from './auth/TextDialogue/TextDialogue.component';
import { TShirtComponent } from './auth/tshirt/tshirt.component';
import { DeleteAccountConfirmationComponent } from './feature/store-admin/components/delete-account-confirmation/delete-account-confirmation.component';
import { DirtyCheckGuardGuard } from './feature/store-admin/guard/dirty-check-guard.guard';
import { LeaveSiteConformationDialogComponent } from './shared/components/leave-site-conformation-dialog/leave-site-conformation-dialog.component';
import { OpenAPIComponent } from '@app/feature/public/open-api/open-api.component';
import { StoreNotOnlineComponent } from './shared/components/store-not-online/store-not-online.component';
import { EncrDecrService } from './shared/services/encr-decr-service.service';
import { TermsConditionComponent } from './auth/terms-condition/terms-condition.component';
import { SharedModule } from './shared/shared.module';
import { StoreOfflineW9SComponent } from './shared/components/store-offline-W9S/store-offline-W9S.component';
import { AcceptInvitationComponent } from './auth/accept-invitation/accept-invitation.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { StoreAdminModule } from './feature/store-admin/store-admin.module';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    LayoutComponent,
    TShirtComponent,
    HoodiesComponent,
    AboutUsLandingComponent,
    ContactUsComponent,
    HowItWorksComponent,
    LoginComponent,
    SignupComponent,
    TextDialogueComponent,
    ResetpasswordComponent,
    ConfirmEmailComponent,
    ConfirmDialougeComponent,
    ForceChangePasswordComponent,
    StoreNotOnlineComponent,
    StoreOfflineW9SComponent,
    OpenAPIComponent,
    TermsConditionComponent,
    AcceptInvitationComponent,
    DeleteAccountConfirmationComponent
  ],
  imports: [
    LayoutModule,
    BrowserModule,
    BrowserAnimationsModule, // required animations module
    MaterialModule,
    AppRoutingModule,
    CoreModule,
    ToastrModule.forRoot(), // ToastrModule added,
    ReactiveFormsModule,
    AngularEditorModule,
    FormsModule,
    SharedModule,
    StoreAdminModule,
    PrivacyPolicyComponent,
    MatInputModule
  ],
  exports: [
    MaterialModule
  ],
  providers: [
    StoreAdminAuthGuard,
    UserGuard,
    SuperAdminAuthGuard,
    CookieService,
    EncrDecrService,
    DirtyCheckGuardGuard,
    provideAnimationsAsync()
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
}
